import React from "react";

const AICricketHome = () => {
  const features = [
    { icon: "fa-gavel", emoji: "🏷️", label: "Team Auctions" },
    { icon: "fa-brain", emoji: "🧠", label: "AI Coach" },
    { icon: "fa-users", emoji: "👀", label: "Join the Crowd" },
    { icon: "fa-star", emoji: "⭐", label: "Fan Ratings" },
    { icon: "fa-fire", emoji: "🔥", label: "Streak Power" },
    { icon: "fa-video", emoji: "🎬", label: "MatchReplay" },
  ];

  return (
    <div className="min-h-screen w-full overflow-hidden bg-slate-950 text-white">
      <div className="relative min-h-screen">
        <div className="pointer-events-none absolute -left-32 top-10 h-72 w-72 rounded-full bg-purple-600/20 blur-3xl" />
        <div className="pointer-events-none absolute -right-32 top-40 h-80 w-80 rounded-full bg-fuchsia-500/10 blur-3xl" />
        <div className="pointer-events-none absolute bottom-0 left-1/2 h-64 w-64 -translate-x-1/2 rounded-full bg-violet-500/10 blur-3xl" />

        <div className="relative mx-auto flex min-h-screen w-full max-w-6xl flex-col px-4 pb-8 pt-5 sm:px-6 lg:px-8">
          <header className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-purple-600/20 text-xl ring-1 ring-purple-400/20">
                🟣
              </div>
              <div>
                <div className="text-sm font-bold tracking-wide text-white">Think5Whys PurpleDoor</div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-purple-300">AI Cricket League</div>
              </div>
            </div>

            <div className="rounded-full border border-purple-400/20 bg-white/5 px-3 py-1.5 text-[11px] font-semibold text-purple-200 backdrop-blur">
              <i className="fa-solid fa-bolt mr-1 text-yellow-300" />
              Something BIG is coming
            </div>
          </header>

          <main className="flex flex-1 flex-col items-center justify-center py-10 text-center sm:py-14">
            <div className="mb-5 flex flex-wrap justify-center gap-2">
              <span className="rounded-full border border-purple-400/20 bg-purple-500/10 px-3 py-1.5 text-xs font-semibold text-purple-200">
                🏏 Not just cricket
              </span>
              <span className="rounded-full border border-fuchsia-400/20 bg-fuchsia-500/10 px-3 py-1.5 text-xs font-semibold text-fuchsia-200">
                🤖 Powered by AI
              </span>
              <span className="rounded-full border border-yellow-400/20 bg-yellow-500/10 px-3 py-1.5 text-xs font-semibold text-yellow-200">
                🔥 Built for you
              </span>
            </div>

            <div className="mb-5 text-6xl drop-shadow-[0_0_30px_rgba(168,85,247,0.35)] sm:text-7xl">
              🏏
            </div>

            <div className="mb-3 text-xs font-bold uppercase tracking-[0.35em] text-purple-300 sm:text-sm">
              PurpleDoor presents
            </div>

            <h1 className="max-w-4xl text-4xl font-black leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
              AI CRICKET
              <span className="block bg-gradient-to-r from-purple-300 via-fuchsia-300 to-white bg-clip-text text-transparent">
                LEAGUE
              </span>
            </h1>

            <p className="mt-6 max-w-2xl text-base leading-7 text-slate-300 sm:text-lg">
              Your team. Your decisions. Your moments.
              <span className="block font-semibold text-white">
                And maybe... your biggest cricket story yet. 👀
              </span>
            </p>

            <div className="mt-7 flex flex-wrap justify-center gap-2">
              {[
                "🏷️ Own",
                "💰 Bid",
                "🧠 Decide",
                "🏏 Play",
                "⭐ Get Rated",
                "🎬 Replay",
                "📲 Challenge",
              ].map((chip) => (
                <span
                  key={chip}
                  className="rounded-full border border-white/10 bg-white/[0.06] px-3 py-1.5 text-xs font-medium text-slate-200 shadow-sm backdrop-blur"
                >
                  {chip}
                </span>
              ))}
            </div>

            <div className="mt-9 w-full max-w-3xl">
              <div className="relative overflow-hidden rounded-3xl border border-purple-400/20 bg-gradient-to-br from-purple-950/80 via-slate-900 to-fuchsia-950/40 p-5 shadow-2xl shadow-purple-950/30 sm:p-7">
                <div className="absolute right-0 top-0 text-7xl opacity-[0.07] sm:text-9xl">
                  🏆
                </div>

                <div className="relative">
                  <div className="mb-3 flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-purple-300">
                    <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-purple-400" />
                    League Loading
                    <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-purple-400" />
                  </div>

                  <h2 className="text-xl text-yellow-100 font-extrabold sm:text-2xl">
                    Are you ready to own the game?
                  </h2>

                  <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-slate-400 sm:text-base">
                    The pitch is waiting. The teams are getting ready.
                    Something is about to enter PurpleDoor.
                  </p>

                  <div className="mt-6 flex items-center justify-center gap-2">
                    <div className="h-2 w-2 rounded-full bg-purple-400" />
                    <div className="h-2 w-10 rounded-full bg-purple-500/50" />
                    <div className="h-2 w-2 rounded-full bg-purple-300" />
                    <div className="h-2 w-16 rounded-full bg-purple-500/30" />
                    <div className="h-2 w-2 rounded-full bg-purple-400" />
                  </div>

                  <div className="mt-6 inline-flex items-center gap-2 rounded-2xl border border-yellow-400/20 bg-yellow-400/5 px-4 py-3 text-sm font-semibold text-yellow-200">
                    <span className="text-lg">🔥</span>
                    Keep your Streak alive.
                    <span className="text-slate-500">|</span>
                    You may need it.
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 grid w-full max-w-3xl grid-cols-2 gap-3 sm:grid-cols-3">
              {features.map((feature) => (
                <div
                  key={feature.label}
                  className="group rounded-2xl border border-white/10 bg-white/[0.035] p-4 text-left transition-all duration-300 hover:-translate-y-1 hover:border-purple-400/30 hover:bg-purple-500/[0.06]"
                >
                  <div className="flex items-center gap-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/[0.06] text-xl">
                      {feature.emoji}
                    </div>

                    <div className="min-w-0">
                      <div className="text-xs text-slate-400">
                        <i className={`fa-solid ${feature.icon} mr-1`} />
                        Coming
                      </div>
                      <div className="mt-0.5 truncate text-sm font-bold text-white">
                        {feature.label}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-9 flex flex-col items-center gap-3">
              <div className="inline-flex items-center gap-2 rounded-full border border-purple-400/20 bg-purple-500/10 px-5 py-2.5 text-sm font-bold text-purple-200">
                <i className="fa-solid fa-hourglass-half" />
                Arrival loading...
              </div>

              <p className="max-w-md text-xs leading-5 text-slate-500">
                Stay active. Stay curious. And don't let your Streak break.
              </p>
            </div>
          </main>

          <footer className="pt-6 text-center">
            <div className="text-[10px] uppercase tracking-[0.3em] text-slate-600">
              PurpleDoor • Think5Whys
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default AICricketHome;